
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mendable-api/chat",
      function () {
        return require("private-next-pages/mendable-api/chat.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mendable-api/chat"])
      });
    }
  